module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex appointment"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('appointment-profile', {
    attrs: {
      "appointment": _vm.appointment,
      "edit_id": _vm.edit_id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-support"
  }, [_c('appointment-history', {
    attrs: {
      "appointment": _vm.appointment,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id,
      "type": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d49c9f32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Appointment/AppointmentIndex.vue
// module id = 1464
// module chunks = 0